import React from 'react';
import { Reveal } from './Reveal';
import { StrategyMenuButton } from './StrategyMenuButton';
const openingMoves = ['Shape the discourse', 'Set the agenda', 'Prime the audience', 'Introduce the narrative', 'Start the first conversation'];
export function ActOneBeforeSlide() {
  return <main className="relative flex h-full w-full flex-col overflow-hidden bg-[#F4F1E8] text-[#0A0A0A]" data-id="element-4" data-mp="1tah46z5awbp9">
      <StrategyMenuButton data-id="element-5" data-mp="1ya3fv45hdjvy" />
      <div className="h-[30vh] w-full shrink-0 overflow-hidden bg-[#202F65]" data-id="element-6" data-mp="1y8sbb247o83s">
        <img src="https://cdn.magicpatterns.com/uploads/if7raDbjjRP99osG96DqGP/Screenshot_2026-09-01_at_12.40.24.png" alt="ECCO'27 Congress poster, March 3–6 2027, Bella Center, Copenhagen" width="2554" height="1276" loading="eager" decoding="async" className="w-full h-auto -translate-y-[17%] object-cover" data-id="element-7" data-mp="237d4wioyjtj9" />
      </div>

      <div className="flex min-h-0 flex-1 flex-col px-[6%] pb-[4.5%] pt-[2.5vh]" data-id="element-8" data-mp="2lzxrjie2d2em">
          <div className="flex items-center gap-[1vw] font-sans text-[clamp(12px,1vw,18px)] font-semibold tracking-[0.16em]" data-id="element-9" data-mp="100dy5y83fo0n">
            <span className="text-black/35" data-id="element-10" data-mp="vwz5o82yxf6b">Act I</span>
            <span className="h-px w-[clamp(24px,2.6vw,46px)] bg-[#D62B22]" data-id="element-11" data-mp="qz7hnp5g2d7e" />
            <span className="text-[#D62B22]" data-id="element-12" data-mp="r1accmhjkuig">Before</span>
          </div>

          <h1 className="mt-[1.6vh] font-display text-[clamp(42px,5.6vw,92px)] font-bold leading-[0.94] tracking-[-0.03em]" data-id="element-13" data-mp="m277p35h4qb0">
            Set the scene
          </h1>
          <p className="mt-[1.2vh] max-w-[36ch] font-display text-[clamp(19px,1.9vw,32px)] font-medium leading-[1.15] text-black/60" data-id="element-14" data-mp="1eos1sbdc3gi9">
            A congress begins before the venue.
          </p>

          <div className="mt-[2.4vh] grid grid-cols-5 border-y border-black/20 py-[2.2vh]" data-id="element-15" data-mp="1500b06k0f28x">
            {openingMoves.map((move, index) => <div key={move} className={`min-w-0 pr-[1.3vw] ${index > 0 ? 'border-l border-black/15 pl-[1.3vw]' : ''}`} data-id="element-16" data-mp="22gpa3shkrqem" data-mpi={index}>
                <span className="font-sans text-[clamp(11px,0.8vw,15px)] font-semibold tracking-[0.12em] text-[#D62B22]" data-id="element-17" data-mp="3rx1by4wl3dr9">
                  0{index + 1}
                </span>
                <p className="mt-[0.8vh] max-w-[10ch] font-display text-[clamp(22px,2.2vw,39px)] font-semibold leading-[1.02] tracking-[-0.015em] text-black" data-id="element-18" data-mp="3i6gcygd0077t">
                  {move}
                </p>
              </div>)}
          </div>

          <Reveal className="mt-auto flex items-end justify-between gap-[3vw] pt-[1.8vh]" delay={0.12} data-id="element-19" data-mp="389v9hzgmn463">
            <p className="max-w-[20ch] font-display text-[clamp(22px,2.4vw,42px)] font-semibold leading-[1.08]" data-id="element-20" data-mp="3d4r519l2o9ny">
              Don’t wait for the booth to start the story.
            </p>
            <p className="max-w-[36ch] text-right font-sans text-[clamp(12px,0.95vw,17px)] leading-snug text-black/45" data-id="element-21" data-mp="346fc30wqgzsc">
              Before ECCO, Takeda can start the discourse rather than simply announce attendance.
            </p>
          </Reveal>
      </div>
    </main>;
}